import CountrySelect from '@components/CountrySelect'
import { Field } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { FormFields } from '../types'
import { FormField } from '@generated'

type AddressFieldsProps = {
  isNewApiStructure?: boolean
  fields?: FormFields
}

export const AddressFields: FC<AddressFieldsProps> = ({ isNewApiStructure = false, fields }) => {
  const { t } = useTranslation('forms')

  const getLabel = (baseLabel: string): string => {
    if (!isNewApiStructure || !fields) {
      return baseLabel
    }

    const isMandatory = fields.find((f) => f.type === FormField.HomeAddress)?.mandatory ?? false
    return isMandatory ? baseLabel : `${baseLabel} - ${t('optional', { ns: 'forms' })}`
  }

  return (
    <>
      <Field name="street" label={getLabel(t('labels.street'))} field="input" gridColumn="span 5" />
      <Field
        field="input"
        name="houseNumber"
        label={getLabel(t('labels.houseNumber'))}
        gridColumn={{ _: 'span 7', large: 'span 4' }}
      />
      <Field
        field="input"
        name="houseNumberSuffix"
        label={t('labels.houseNumberSuffix')}
        gridColumn={{ _: 'span 5', large: 'span 3' }}
      />
      <Field
        field="input"
        name="postalCode"
        label={getLabel(t('labels.postalCode'))}
        gridColumn={{ _: 'span 12', large: 'span 5' }}
        autoComplete="postal-code"
      />
      <Field
        name="city"
        label={getLabel(t('labels.city'))}
        field="input"
        gridColumn={{ _: 'span 12', large: 'span 7' }}
        autoComplete="address-level2"
      />
      <CountrySelect name="country" label={getLabel(t('labels.country'))} />
    </>
  )
}
